var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"w-full",class:_vm.height,attrs:{"element-loading-background":_vm.bg}})
}
var staticRenderFns = []

export { render, staticRenderFns }